import Accordion from "components/blocks/Accordion";
import AccordionItem from "components/blocks/Accordion/AccordionItem";
import AttachmentCard from "components/blocks/AttachmentCard";
import { useTranslation } from "react-i18next";
import FormViewComponent from "components/formBuilder/FormViewComponent";
import ExaminerEvaluationForm, { ExaminerEvaluationFormRef } from "./ExaminerEvaluationForm";
import { forwardRef } from "react";
import {OpenPublishingTaskResult} from "../../../../../services/tasks/models/tasksTypes";
import {ExaminerOrderEvaluationFormResult} from "../../../../../services/examinersService/Model/ExaminerTypes";
import {CourseLocalItemResult} from "../../../../../services/courseService/models/CourseType";
import {useNotification} from "../../../../../hooks/useNotification";

const ExaminerTaskContent = forwardRef<
  ExaminerEvaluationFormRef,
  {
    task: ExaminerOrderEvaluationFormResult | null;
    serialGuid: string;
    openedTask: OpenPublishingTaskResult | null;
    program?: CourseLocalItemResult | null;
    isReadOnly: boolean|null;
  }
>(({ program,task, serialGuid, openedTask,isReadOnly }, ref) => {
  const { t ,i18n} = useTranslation(["ExaminerTask", "Common"]);
    const { showNotification } = useNotification();
    const handleFormClick = () => {
        if (isReadOnly) {
            showNotification({
                description: t("youMustAcceptTaskToFillForm"),
                type: "notification"
            });
        }
    };
    const programDetails = program?.courseDetails.find(
        (item) => i18n.language === item.locale?.toLocaleLowerCase(),
    );
  return (
    <div className="d-flex flex-column" onClick={handleFormClick}>
        
      <div>
          {task?.formBuilderSchema &&(<>  <h6 className="fw-bold mt-4">{t("fullDescription")} </h6>
        <FormViewComponent
          readOnly
          data={task?.formValue ? JSON.parse(task.formValue) : {}}
          formDefinition={task?.formBuilderSchema ? JSON.parse(task?.formBuilderSchema) : {}}
          onChange={() => {}}
        /></>)}
      </div>

      <div className="divider mt-4" />

      <Accordion>
        <AccordionItem title={t("researchCentre")} initiallyOpen elementId="research-center">
          <div className="d-flex gap-3">
            {task?.courseOrderEvaluationFiles.map((attachment, index) => (
              <AttachmentCard
                key={attachment.id}
                attachment={{
                  id: attachment.id,
                  extension: attachment.extension ?? "",
                  fileName: attachment.name ?? "",
                  size: attachment.size ?? "",
                }}
              />
            ))}
          </div>

          <div>
            <h6 className="fw-bold mt-4">{t("notes")}</h6>
            <p className="my-0">{task?.notes ?? t("Common:noData")}</p>
          </div>
        </AccordionItem>
      </Accordion>
      <div className="divider" />
      <ExaminerEvaluationForm
        ref={ref}
        evaluationForm={task?.evaluationForm}
        serialGuid={serialGuid}
        examinerEvaluationFormValue={task?.examinerEvaluationFormValue}
        openedTask={openedTask}
        isReadOnly={isReadOnly}
      />
    </div>
  );
});

export default ExaminerTaskContent;
